import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
/* import mainlogo from "../../assets/images/white Logo.png";
import logo from "../../assets/images/white Logo.png"; */
import mainlogo from "../../assets/icons/white Logo-1.png";
import logo from "../../assets/icons/white Logo-1.png";
import EP2 from "../../assets/images/EP2.jpg";
import { toast } from "react-toastify";
import exit from "../../assets/svg/exit.svg";
import { removeUser } from "../../redux/slices/accountSlice";
import { logOut, switchAccount } from "../../redux/slices/authSlice";
import { setPostReload } from "../../redux/slices/tempSlice";
import { resetNotificationsCount } from "../../redux/slices/notificationSlice";
import axios from "../Hooks/axios";
import { setCookies } from "../Hooks/setCookies";
import styles from "./Header.module.css";
import logout from "../../assets/images/whiteLogout.png";
import close from "../../assets/images/closeHeader.png";
import ChatImg from "../../assets/images/Chat.png";
import Persona from "../../assets/images/Persona.png";
import Setting from "../../assets/images/Setting.png";
import NotificationImg from "../../assets/images/Bell.png";
import Search from "../../assets/images/search.png";
import HomeImg from "../../assets/images/HomeActive.png";
import { FaPlus } from "react-icons/fa6";
import { TfiPlus } from "react-icons/tfi";
import { PiMagicWandFill } from "react-icons/pi";
import Notification from "../Small_Header/Notification";
import Avatar from "../Avatar/Avatar";
import { IoIosArrowBack } from "react-icons/io";
import { toggleTheme } from "../../redux/slices/themeSlice";
import Switch from "react-switch";
// import { setCookies } from "../../components/Hooks/setCookies";
import defaultProfileImg from "../../assets/images/user.png";

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [LogoutPopup, setLogoutPopup] = useState(false);
    const { userId, user, token } = useSelector((state) => state.auth);
    const { users } = useSelector((state) => state.account);
    const [showNotification, setShowNotification] = useState(false);
    const { notificationsCount } = useSelector((state) => state.notification);
    const [showSearch, setShowSearch] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    // const [activeItem, setActiveItem] = useState(0)

    // console.log(users[0].userId);

    const handelLogout = () => {
        toast.success("Logout SuccessFully!!");
        setLogoutPopup(false);
        if (users.length <= 1) {
            dispatch(logOut());
            navigate("/", { replace: true });
            if (users.length === 1) dispatch(removeUser(users[0].userId));
        } else {
            const data = users.find((obj) => userId === obj.userId);
            if (!data) {
                // If current user not found in list, just log out everything
                dispatch(logOut());
                navigate("/", { replace: true });
                return;
            }
            const index = users.indexOf(data);
            if (index === 0) {
                dispatch(switchAccount({ userId: users[1].userId, user: users[1].user, token: users[1].token }));
                dispatch(removeUser(data.userId));
            } else {
                dispatch(switchAccount({ userId: users[0].userId, user: users[0].user, token: users[0].token }));
                dispatch(removeUser(data.userId));
            }
        }
    };

    const [isHeaderClosed, setIsHeaderClosed] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleHeader = () => {
        setIsHeaderClosed(!isHeaderClosed);
    };

    const { pathname } = useLocation();

    useEffect(() => {
        setShowSearch(false);
    }, [pathname, showNotification]);

    const createRef = useRef(null);

    // const handleCreateChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         navigate("/UploadPost2", {
    //             state: { fileData: file },
    //         });
    //     } else {
    //         toast.error("Please Select a File !");
    //     }
    //     e.target.value = null;
    // };

    const mode = useSelector((state) => state.theme.mode);
    console.log(mode);

    useEffect(() => {
        // Apply theme to <html> tag
        document.documentElement.setAttribute("data-theme", mode);
    }, [mode]);

    const [ActiveStatus, setActiveStatus] = useState(true);

    const profileImage =
        user?.ProfilePic && user.ProfilePic.trim() !== ""
            ? user.ProfilePic
            : defaultProfileImg;

    return (
        <>
            {showNotification && <Notification setShowNotification={setShowNotification} />}
            <div className={`${styles.header}`}>
                <nav className={`${styles.HeaderContainer}`}>
                    <div className={styles.leftContainer}>
                        <div className={styles.logoContainer} >
                            <Link to="/Home">
                                <img src={width < 300 ? mainlogo : logo} alt="logo" />
                                <p style={{ color: isMobile ? "#FFFFFF" : "" }}>fameo-X</p>
                            </Link>
                        </div>

                        {!isMobile && pathname === "/Home" && (
                            <div
                                className={styles.createBtn}
                                onClick={() => {
                                    navigate("/UploadPost2");
                                }}
                            >
                                <button>
                                    {" "}
                                    <TfiPlus /> Create
                                </button>
                                {/* <input
                                    type="file"
                                    accept="image/*,video/*"
                                    style={{ display: "none" }}
                                    ref={createRef}
                                    onChange={(e) => handleCreateChange(e)}
                                /> */}
                            </div>
                        )}

                        {isMobile && pathname === "/Home" && (
                            <div className={styles.MobileLeftHeader}>
                                <div
                                    className={styles.createBtn}
                                    onClick={() => {
                                        navigate("/UploadPost2");
                                    }}
                                >
                                    <button>
                                        {" "}
                                        <TfiPlus /> Create
                                    </button>
                                    {/* <input
                                        type="file"
                                        accept="image/*,video/*"
                                        style={{ display: "none" }}
                                        ref={createRef}
                                        onChange={(e) => handleCreateChange(e)}
                                    /> */}
                                </div>
                                <div className={styles.MobileProfile}>
                                    <Link
                                        onClick={() => {
                                            console.log("Header Persona Call :", token, userId);
                                            setCookies({
                                                url: `${process.env.REACT_APP_TEMPLATE_BASE_URL}`,
                                                token,
                                                personaUserId: userId,
                                                currentUserId: userId,
                                            });
                                        }}
                                    >
                                        <div className={styles.ProfilePic}>
                                            <Avatar src={user?.ProfilePic} name={user?.displayName || user?.username} />
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        )}

                        {isMobile && pathname !== "/Home" && (
                            <div className={styles.MobileLeftHeader}>
                                <div className={styles.BackButton}>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                    >
                                        {" "}
                                        <IoIosArrowBack />
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {isMobile ? null : (
                        <div className={`${styles.navContainer} ${mode === "dark" ? styles.dark : ""}`}>
                            <ul>
                                <li>
                                    <Link
                                        onClick={() => {
                                            console.log("Header Persona Call :", token, userId);
                                            setCookies({
                                                url: `${process.env.REACT_APP_TEMPLATE_BASE_URL}`,
                                                token,
                                                personaUserId: userId,
                                                currentUserId: userId,
                                            });
                                        }}
                                    >
                                        <div className={styles.ProfilePic}>
                                            <Avatar src={user?.ProfilePic} name={user?.displayName || user?.username} />
                                        </div>
                                    </Link>
                                </li>
                                <li>
                                    <div className={`${styles.ListItem} ${pathname === "/Home" ? styles.ActiveItem : ""}`}>
                                        <Link to="/Home" onClick={() => dispatch(setPostReload(true))} id="Home">
                                            <img src={HomeImg} alt="Home" />
                                        </Link>
                                        <label htmlFor="Home">Home</label>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        title="Search"
                                        className={`${styles.ListItem} ${pathname === "/Explore" ? styles.ActiveItem : ""}`}
                                    >
                                        <Link to="/Explore" onClick={() => dispatch(setPostReload(true))} id="Explore">
                                            <img src={Search} alt="Explore" />
                                        </Link>
                                        <label htmlFor="Explore">Search</label>
                                    </div>
                                </li>
                                <li>
                                    <div title="Chat" className={`${styles.ListItem} ${pathname === "/Chat" ? styles.ActiveItem : ""}`}>
                                        <Link to="/Chat" onClick={() => dispatch(setPostReload(true))} id="ChatItem">
                                            <img src={ChatImg} alt="Chat" />
                                        </Link>
                                        <label htmlFor="ChatItem">Chat</label>
                                    </div>
                                </li>
                                <li>
                                    <div title="Notification" className={styles.ListItem}>
                                        <Link onClick={() => {
                                            const nextState = !showNotification;
                                            setShowNotification(nextState);
                                            if (nextState) {
                                                dispatch(resetNotificationsCount());
                                                if (userId) axios.get(`/notification/seenAll/${userId}`).catch((e) => console.log(e));
                                            }
                                        }}>
                                            {notificationsCount > 0 && <div className={styles.redDot}>{notificationsCount}</div>}
                                            <img src={NotificationImg} alt="Notification" />
                                        </Link>
                                    </div>
                                </li>
                                <li>
                                    <div
                                        title="Ask Fameo AI"
                                        className={`${styles.ListItem} ${pathname.startsWith("/AskFameoAI") ? styles.ActiveItem : ""}`}
                                    >
                                        <Link to="/AskFameoAI" id="AskFameoAIItem">
                                            <PiMagicWandFill className={styles.askFameoNavIcon} />
                                        </Link>
                                        <label htmlFor="AskFameoAIItem">Ask Fameo AI</label>
                                    </div>
                                </li>

                                {/* <li>
								<div className={styles.ListItem}>
									<Link
										onClick={() => {
											// if (user?.personalTemplate === "") toast.info("You didn't have a persona");
											// else
											setCookies({
												url: `${process.env.REACT_APP_TEMPLATE_BASE_URL}`,
												token,
												personaUserId: user._id,
												currentUserId: user._id,
											});
										}}>
										<img src={Persona} alt="Persona" />
									</Link>
								</div>
							</li> */}

                                {/*
								Ecom menu(to be implemented in future)
								<li>
									<div title="Explore" className={`${styles.ListItem} ${pathname === "/Explore" ? styles.ActiveItem : ""}`}>
										<Link to={`/Explore`}  onClick={() => dispatch(setPostReload(true))} id="Explore">
											<img src={Persona} alt="Persona" />
										</Link>
										<label htmlFor="Explore">Explore</label>
									</div>
								</li> */}
                                {/* {isMobile ? <li className={styles.update}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								width="24"
								height="24"
								color="#ffffff"
								fill="none">
								<path
									d="M12 4V20"
									stroke="currentColor"
									stroke-width="1.5"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
								<path
									d="M4 12H20"
									stroke="currentColor"
									stroke-width="1.5"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
							<Link>Update</Link>
						</li> : null} */}
                                <li>
                                    <div className={`${styles.ListItem} ${pathname === "/Setting" ? styles.ActiveItem : ""}`}>
                                        <Link to="/Setting" onClick={() => dispatch(setPostReload(true))} id="Setting">
                                            {/* Home */}
                                            <img src={Setting} alt="Setting" />
                                        </Link>
                                        <label htmlFor="ChatItem">Setting</label>
                                    </div>
                                </li>

                                <li>
                                    <Switch
                                        className={styles.switch}
                                        onChange={() => dispatch(toggleTheme())}
                                        checked={mode === "dark" ? true : false}
                                        offColor={"#F3DFF3"}
                                        onColor={"#FFFFFF"}
                                        offHandleColor={"#A6539D"}
                                        onHandleColor={"#A6539D"}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        activeBoxShadow={"0 0 0px 0px #909AFF"}
                                        height={isMobile ? 20 : 30}
                                        width={isMobile ? 44 : 64}
                                    />
                                </li>


                                {/* <li>
							<Link to="/Explore">Explore</Link>
						</li>
						<li>
							<Link to="/Chat">Chat</Link>
						</li>
						<li>
							<Link to="/Setting">Setting</Link>
						</li>
						<li>
							<div className={styles.logoutContainer}>
								{isMobile ? (
									<Link onClick={() => setLogoutPopup(true)}>
										<img src={logout} alt="exit" />
									</Link>
								) : (
									<Link onClick={() => setLogoutPopup(true)}>
										<img src={exit} alt="exit" />
									</Link>
								)}
							</div>
						</li> */}
                            </ul>
                        </div>
                    )}

                    {/* <div className={styles.logoutContainer}>
				{isMobile ? (
					<Link onClick={() => setLogoutPopup(true)}>
						<img src={logout} alt="exit" />
					</Link>
				) : (
					<Link onClick={() => setLogoutPopup(true)}>
						<img src={exit} alt="exit" />
					</Link>
				)}
			</div> */}
                </nav>

                {LogoutPopup && (
                    <div className={styles.LogoutPopup}>
                        <h1>
                            Do You Want To <span>End Live ?</span>
                        </h1>
                        <div>
                            <button type="button" onClick={handelLogout}>
                                Log Out
                            </button>
                            <button type="button" onClick={() => setLogoutPopup(false)}>
                                Cancel
                            </button>
                        </div>
                    </div>
                )}

                {/* {
					isMobile ? (
						<div className={`${styles.toggleHeader} ${isHeaderClosed ? styles.closedHamburger : ""}`} onClick={toggleHeader}>
							{" "}
							<img src={close} alt="" />{" "}
						</div>
					) : null
				} */}
            </div>
        </>
    );
};

export default Header;


